import {authenticationParameters, authProvider, baseAPIURL} from "./authProvider";
import {getRequestOptions, headers, testHttpClient} from "../api";
import jsonServerProvider from "ra-data-json-server";
import {GetListResult, GetListParams, DataProvider, GetOneResult, GetManyResult, HttpError} from 'react-admin';
import {stringify} from "querystring";

const dataProvider = jsonServerProvider(baseAPIURL, testHttpClient);

const defaultRes: GetListResult = {
  data: [],
  total: 0,
}

const getRange = (pagination: {page: number, perPage: number}) => {
  return [(pagination.page-1)*pagination.perPage, pagination.page*pagination.perPage-1]
}

const sortTransform = (field: string) => {
  return checkAndReplaceId(field)
}

const filterTransform = (filter: any) => {
  let newFilter: any = {}
  for (const [key, value] of Object.entries(filter)) {
    newFilter = flattenObject(key, value)
  }
  return newFilter
}

const flattenObject = (mainKey: string, obj: any) => {
  const outputObject: any = {}
  if (typeof obj == "object") {
    for (const [key, value] of Object.entries(obj ?? {})) {
      const innerObj = flattenObject(key, value)
      for (const [innerKey, innerValue] of Object.entries(innerObj ?? {})) {
        outputObject[mainKey+"."+innerKey] = innerValue
      }
    }
  } else {
    outputObject[mainKey] = obj
  }
  return outputObject
}

const checkAndReplaceId = (input: string) => {
    if (["customerId", "createdByUserId", "startedByUserId"].indexOf(input) >= 0) {
      return input.replace("Id","")
    } else {
      return input
    }
}

export const customizedDataProvider = {
  ...dataProvider,
  getList: (resource: string, params: GetListParams) => {
    const query = {
      sort: params.sort.field === "id" ? null : JSON.stringify([sortTransform(params.sort.field), params.sort.order]),
      range: JSON.stringify(getRange(params.pagination)),
      filter: JSON.stringify(filterTransform(params.filter)),
    };
    console.log(query)
    const url = `${baseAPIURL}${resource}?${stringify(query)}`;
    return new Promise(((resolve, reject) => {
      fetch(url.toString(), {
        method: 'GET',
        headers: headers()
      })
        .then(response => {
          if (response.status < 200 || response.status >= 300) {
            // @ts-ignore
            resolve(defaultRes)
            if (response.status === 401) {
              authProvider.getIdToken(authenticationParameters).then(()=>{
                console.log("new token received")
                }
              )
            }
          }
          console.log(resource)
          return response.json()
        })
        .then(result => {
          const res: GetListResult = {
            data: result.data,
            total: result.total,
          }
          console.log(res)
          // @ts-ignore
          resolve(res)
        })
        .catch(e => {
          console.log(e);
          // @ts-ignore
          resolve(defaultRes)
        });
    }))
  },

  getOne: (resource, params) => {
    return new Promise(((resolve, reject) => {
    fetch(`${baseAPIURL}${resource}/${params.id}`, getRequestOptions())
      .then(response => {
        console.log("getOne")
        return response.json()
      })
      .then(result => {
        console.log(result)
        const res: GetOneResult = {
          data: result
        }
        // @ts-ignore
        resolve(res)
      })
      .catch(e => {
        console.log(e);
        reject()
      });
    }))
  },

  getMany: (resource, params) => {
    return new Promise(((resolve, reject) => {
      console.log(resource)
      console.log("getMany")
      fetch(baseAPIURL + resource, {
        method: 'GET',
        headers: headers(),
      })
        .then(response => {
          if (response.status < 200 || response.status >= 300) {
            reject()
          }
          return response.json()
        })
        .then(result => {
          const res: GetManyResult = {
            data: result.data.filter((item: any) => params.ids.includes(item.id))
          }
          console.log(res)
          // @ts-ignore
          resolve(res)
        })
        .catch(e => {
          console.log(e);
          reject()
        });
    }))
  },

  create: (resource, params) => {
    return new Promise(((resolve, reject) => {
      fetch(baseAPIURL + resource, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify(params.data),
      })
        .then(response => {
          console.log("create")
          return response.text().then(text => ({
            status: response.status,
            statusText: response.statusText,
            body: text,
          }))
        })
        .then(({ status, statusText, body }) => {
          let json;
          try {
            json = JSON.parse(body);
          } catch (e) {
            // not json, no big deal
          }
          if (status < 200 || status >= 300) {
            console.log(json.toString())
            return reject(
              new HttpError(
                (json && json.toString()) || statusText,
                status,
                json
              )
            );
          }
          resolve({data: json})
        })
        .catch(e => {
          console.log(e);
          reject()
        });
    }))
  },

  delete: (resource, params) => {
    return new Promise(((resolve, reject) => {
      fetch(`${baseAPIURL}${resource}/${params.id}`, {
        method: 'DELETE',
        headers: headers(),
      })
        .then(response => {
          console.log("delete")
          
          return response.json()
        })
        .then(result => {
          console.log({data: result})
          resolve({data: result})
        })
        .catch(e => {
          console.log(e);
          reject()
        });
    }))
  },

  deleteMany: (resource, params) => {
    console.log("deleteMany")
    var promises: Promise<string>[] = []
    params.ids.forEach((id, index) => {
      promises[index] = new Promise((resolve, reject) => {
        fetch(`${baseAPIURL}${resource}/${id}`, {
          method: 'DELETE',
          headers: headers(),
        })
          .then(response => {
            console.log("deleteOne")
            
            if (response.status < 200 || response.status >= 300) {
              reject()
            }
            resolve(id.toString())
          })
          .catch(e => {
            console.log(e);
            reject()
          });
      });
    })
    return Promise.all(promises).then(values => { return {data: values} })
  },

  update: (resource, params) => {
    console.log("update")
    console.log(params)
    return new Promise(((resolve, reject) => {
      fetch(`${baseAPIURL}${resource}/${params.id}`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(params.data),
    })
        .then(response => {
          return response.text().then(text => ({
            status: response.status,
            statusText: response.statusText,
            body: text,
          }))
        })
        .then(({ status, statusText,  body }) => {
          let json;
          try {
            json = JSON.parse(body);
          } catch (e) { console.log(e); }
          if (status < 200 || status >= 300) {
            console.log(json.toString())
            console.log("reject update");
            return reject(
              new HttpError(
                (json && json.toString()) || statusText,
                status,
                json
              )
            );
          }
          resolve({data: json})
        })
        .catch(e => {
          console.log(e);
          reject()
        });
    }))
  }
} as DataProvider
